// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3kBpF","fileBtn":"File_fileBtn__2zIUB","closeBtn":"File_closeBtn__3rFnB","fileSelected":"File_fileSelected__oMtV-","disabled":"File_disabled__2XT6S"};